<!-- =========================================================================================
  File Name: ChartjsComponentBarChart.vue
  Description: Chartjs component - Bar Chart
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<script>
import { Bar } from 'vue-chartjs'

// eslint-disable-next-line no-unused-vars
export default {
  extends: Bar,
  data () {
    return {
      data: {
        labels:[],
        datasets: [
          {
            label: '',
            backgroundColor: [],
            data:[]
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: ''
        }
      }
    }
  },
  mounted () {
    this.$http.get('dashboardAdmin/')
      .then((response) => {
        if (response.data.letters_analytics && response.data.letters_analytics.monthly_trend) {
        // Ordre des mois
          const months = [
            'month_1', 'month_2', 'month_3', 'month_4', 'month_5', 'month_6',
            'month_7', 'month_8', 'month_9', 'month_10', 'month_11', 'month_12'
          ]
          // Labels pour le graphique
          const monthLabels = [
            'Jan',  // Janvier
            'Fév',  // Février
            'Mar',  // Mars
            'Avr',  // Avril
            'Mai',  // Mai
            'Juin', // Juin
            'Juil', // Juillet
            'Aoû',  // Août
            'Sep',  // Septembre
            'Oct',  // Octobre
            'Nov',  // Novembre
            'Déc'   // Décembre
          ]

          // Mois actuel (1 à 12)
          const currentMonthNumber = new Date().getMonth() + 1

          // Tronquer labels et données jusqu’au mois courant
          this.data.labels = monthLabels.slice(0, currentMonthNumber)
          // Dataset unique pour le monthly_trend
          this.data.datasets = [
            {
              label: 'Lettres par mois',
              backgroundColor: '#2A7B9B',
              borderColor: '#2A7B9B',
              data: months.slice(0, currentMonthNumber).map(m => response.data.letters_analytics.monthly_trend[m] || 0)
            }
          ]
        }
        this.renderChart(this.data, this.options)
      })
  }
}
</script>
